/**
 * MESSAGE POPUP ENTRY POINT
 *
 * This component is used for rendering warnings, infos and error messages in a popup.
 *
 * @version 0.1
 */


import PropTypes from 'prop-types';


import React from 'react';
import { FormattedMessage } from 'react-intl';

import reduxStore from './../../reduxStore';

import actions from './redux/MessagePopup.actions';

/**
 * Individual popup
 */
class MessagePopup extends React.Component {

    static propTypes = {
        type: PropTypes.string,
        popupClasses: PropTypes.string
    }

    constructor(props) {
        super(props);
        this.state = reduxStore.getState().popupMessages;
    }

    componentWillMount() {

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().popupMessages);
            }
        );

    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {

        let popupTitle = null,
            messages   = [];

        if (typeof this.state.popupTitle === 'string') {
            popupTitle = (<h2><FormattedMessage id={this.state.popupTitle} /></h2>);
        }

        if (typeof this.props.type === 'string' && this.props.type.length > 0) {

            for (let i = 0; i < this.state.messages.length; i++) {

                if (this.state.messages[i].messageType === this.props.type) {

                    // Individual messages are composed of a title and a description.
                    let message     = this.state.messages[i],
                        title       = typeof message.titleId === 'string' ?
                            (<h3><FormattedMessage id={ message.titleId } /></h3>) : null,
                        description = typeof message.messageId === 'string' ?
                            (<p><FormattedMessage id={ message.messageId } values={message.values} /></p>) : null;

                    // At least a description must be available in order to add the message.
                    if (description) {
                        messages.push(
                            <div key={'popup-message-' + i} className="message-popup__message-container">
                                { title }
                                { description }
                            </div>
                        );

                    }

                }

            }

        }

        let popupClasses = (messages.length > 0) && (this.state.popupCount > 0) || popupTitle ? 'message-popup slide-down' : 'message-popup';

        if (typeof this.props.popupClasses === 'string') {
            popupClasses += (' ' + this.props.popupClasses);
        }

        return (
            <div className={popupClasses}>
                <div className="message-popup__text">
                    {popupTitle}
                    {messages}
                </div>
                <button type="button" className="message-popup__button" onClick={actions.clearMessages}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.dismiss" />
                </button>
            </div>
        );

    }

}

/**
 * Wrapper containing a popup of each type
 */
function MessagePopups() {

    return (
        <div className="message-popups-wrapper">
            <MessagePopup type="system-error" popupClasses="system-error-popup" />
            <MessagePopup type="user-error" popupClasses="user-error-popup" />
            <MessagePopup type="success" popupClasses="success-popup" />
            <MessagePopup type="info" popupClasses="info-popup" />
        </div>
    );
}

export default MessagePopups;


// WEBPACK FOOTER //
// ./src/scripts/reusable/MessagePopup/MessagePopup.index.jsx